import styled from 'styled-components';

import { TopNavMenuItem } from './TopNavMenuItem';

const TopNavMenu = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0 1rem;
   border-right: 1px solid ${({ theme }) => theme.brandColors.darkBlue};

   ${TopNavMenuItem}:not(:last-child) {
      margin-right: 1rem;
   }

   :last-of-type {
      padding-right: 0;
      border-right: 0;
   }
`;

export { TopNavMenu };
